import { createRouter, createWebHistory } from 'vue-router';
import ServicePage from './components/Pages/ServicePage.vue';
import HomePage from './components/HomePage.vue';
import ProjectsPage from './components/Pages/ProjectsPage.vue';
import ContactUsPage from './components/ContactUsPage.vue';
import AboutUsPage from './components/Pages/AboutUsPage.vue';

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/services', name: 'ServicePage', component: ServicePage },
  { path: '/projects', name: 'ProjectsPage', component: ProjectsPage },
  { path: '/contact-us', name: 'ContactUsPage', component: ContactUsPage },
  { path: '/about-us', name: 'AboutUsPage', component: AboutUsPage },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
